import { mapState } from 'vuex'
import routes from '@/router/routes'
import subscribesToOrderUpdatesOnSocket from '@/mixins/subscribesToOrderUpdatesOnSocket'
import { OrderStatus } from '@/store/order'
import { ApiHttpError } from '@/api'

export default {
  mixins: [subscribesToOrderUpdatesOnSocket],
  data() {
    return {
      fetchedAtLeastOnce: false,
      fetching: false,
      routes,
      entered: false,
      shouldRedirectToReceiptAfterEnter: false
    }
  },
  computed: {
    ...mapState({
      navbarLoading: 'navbar_loading'
    }),
    ...mapState('order', {
      orders: 'orders',
      locks: 'locks'
    }),
    ...mapState('menu', {
      menu: 'menu'
    }),
    orderToken() {
      return this.$route.params.orderToken
    },
    order() {
      return this.orders[this.orderToken] || null
    },
    orderLines() {
      return (this.order && this.order.order_lines) || null
    },
    totalAmount() {
      if (!this.orderLines) {
        return 0
      }
      return this.orderLines.reduce((accumulatedPrice, orderLine) => {
        accumulatedPrice += orderLine.price || 0
        return accumulatedPrice
      }, 0)
    },
    paidAmount() {
      if (!this.order) {
        return 0
      }
      return (this.order.payments || []).reduce((totalPrice, payment) => {
        totalPrice += payment.price || 0
        return totalPrice
      }, 0)
    },
    numUnsentItems() {
      if (!this.orderLines) {
        return 0
      }
      return this.orderLines.reduce((accumulatedQuantity, orderLine) => {
        if (!orderLine.prepared_at) {
          accumulatedQuantity += 1
        }
        return accumulatedQuantity
      }, 0)
    }
  },
  watch: {
    order(order) {
      if (
        order &&
        order.status === OrderStatus.CLOSED &&
        this.$route.name !== routes.TABLE_RECEIPT
      ) {
        if (this.entered) {
          this.redirectToReceipt()
        } else {
          this.shouldRedirectToReceiptAfterEnter = true
        }
      }
    }
  },
  created() {
    this.fetchOrder()
  },
  mounted() {
    this.$bus.$on('NAVBAR_PULLED_DOWN', this.fetchOrder)
    this.$bus.$on('APP_DID_BECOME_ACTIVE', this.fetchOrder)
  },
  beforeDestroy() {
    this.$bus.$off('NAVBAR_PULLED_DOWN', this.fetchOrder)
    this.$bus.$off('APP_DID_BECOME_ACTIVE', this.fetchOrder)

    if (this.io) {
      this.io.disconnect()
    }
  },
  methods: {
    redirectToReceipt() {
      this.$router.push({
        name: routes.TABLE_RECEIPT,
        params: { orderToken: this.orderToken }
      })
    },
    afterEnter() {
      if (
        this.order &&
        this.order.status === OrderStatus.CLOSED &&
        this.$route.name !== routes.TABLE_RECEIPT
      ) {
        this.shouldRedirectToReceiptAfterEnter = true
      }

      if (this.shouldRedirectToReceiptAfterEnter) {
        this.redirectToReceipt()
      } else {
        this.entered = true
      }
    },
    async fetchOrder() {
      if (this.fetching) {
        return
      }
      try {
        this.fetching = true

        if (this.fetchedAtLeastOnce) {
          this.$store.dispatch('SET_NAVBAR_LOADING_STATUS', true)
        }

        // On first fetch, unlock the order if the user left without unlocking
        if (!this.fetchedAtLeastOnce && this.locks.includes(this.orderToken)) {
          await this.$store.dispatch('order/UNLOCK', this.orderToken)
        }

        await Promise.all([
          this.$store.dispatch('order/FETCH', this.orderToken),
          this.$store.dispatch('menu/FETCH')
        ])

        this.fetchedAtLeastOnce = true
      } catch (error) {
        this.$store.dispatch('toast/ERROR', error.message)
        this.$router.push({
          name: this.routes.HOME
        })
      } finally {
        this.fetching = false
        this.$store.dispatch('SET_NAVBAR_LOADING_STATUS', false)
      }
    },
    async canChangeOrder() {
      const unpaidAmountBeforeFetch = this.totalAmount - this.paidAmount
      debugger
      try {
        await this.$store.dispatch('order/FETCH', this.orderToken)
        const unpaidAmountAfterFetch = this.totalAmount - this.paidAmount

        if (this.order.is_locked) {
          throw Error('Ordren er låst, da en anden person er gået til betaling.')
        } else if (unpaidAmountAfterFetch !== unpaidAmountBeforeFetch) {
          throw Error('Ordrens pris har ændret sig. Gennemse ordren og prøv igen.')
        }

        return true
      } catch (error) {
        const type = error instanceof ApiHttpError ? 'toast/ERROR' : 'toast/WARNING'

        this.$store.dispatch(type, error.message)
        return false
      }
    }
  }
}
